import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roadFilled"
const RoadFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.22 1.5C17.573 1.5 17.88 1.736 17.976 2.07L17.993 2.14 21.728 21.564C21.822 22.049 21.45 22.5 20.955 22.5H12.75V18C12.75 17.586 12.414 17.25 12 17.25S11.25 17.586 11.25 18V22.5H3.046C2.55 22.5 2.179 22.05 2.272 21.564L6.008 2.139 6.025 2.07C6.12 1.736 6.427 1.5 6.78 1.5H11.251V6C11.25 6.414 11.585 6.75 12 6.75 12.413 6.75 12.75 6.414 12.75 6V1.5zM12 9.375C11.586 9.375 11.25 9.711 11.25 10.125V13.875C11.25 14.289 11.586 14.625 12 14.625S12.75 14.289 12.75 13.875V10.125C12.75 9.711 12.414 9.375 12 9.375"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RoadFilledIcon
